import { useLocation } from 'react-router';

import config from '@/config';

import DummyGameWrapper from './DummyGameWrapper';
import JuniorGameWrapper from './JuniorGameWrapper';

import type { GameAnswerEvent, GameAudioProps, GameFinishEvent } from '../types';

export type GameWrapperProps = {
	onAnswer?: (event: GameAnswerEvent) => void;
	onFinish?: (event: GameFinishEvent) => void;
} & GameAudioProps;

const GameWrapper = (props: GameWrapperProps) => {
	const location = useLocation();
	const sessionKey = `${location.pathname}${location.search}`;
	const Wrapper = config.is_junior ? JuniorGameWrapper : DummyGameWrapper;

	return <Wrapper key={sessionKey} {...props} />;
};

export default GameWrapper;
